import { LocationStatus, type LocationResponse } from "@models/location";

// Whether the customer's certificate upload (POST locations/me/{id}/cert) takes
// this location: an active one that is Approved or Pending (E12-S5 / #240,
// #437). The API 409s any other status: a rejected location sends its
// certificate with the resubmit, and one waiting for payment is past review.
// Shared by UploadCertificateModal's location list and the location detail
// page's upload button (#320), so the two never disagree.
export const canTakeCertificateUpload = (location: LocationResponse): boolean =>
    location.isActive &&
    (location.status === LocationStatus.Approved ||
        location.status === LocationStatus.Pending);
